import { render, staticRenderFns } from "./LargeDonutChart.vue?vue&type=template&id=6c952575&scoped=true"
import script from "./LargeDonutChart.vue?vue&type=script&lang=js"
export * from "./LargeDonutChart.vue?vue&type=script&lang=js"
import style0 from "./LargeDonutChart.vue?vue&type=style&index=0&id=6c952575&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c952575",
  null
  
)

export default component.exports